interface Props {
  blog: {
    id: number;
    title: string;
    excerpt: string;
    image: string;
    category: string;
    author: string;
    date: string;
    readTime: string;
    content?: string;
  };
  onClick: () => void;
}

const BlogCard: React.FC<Props> = ({ blog, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="cursor-pointer bg-white rounded-3xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 group"
    >
      <div className="relative bg-gray-100 aspect-[16/10] flex items-center justify-center overflow-hidden">
        <img
          src={blog.image}
          alt={blog.title}
          className="max-h-full max-w-full object-contain transition-opacity duration-300 group-hover:opacity-90"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
      </div>
      
      <div className="p-6">
        <span className="inline-block mb-3 px-4 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary">
          {blog.category}
        </span>

        <h3 className="text-xl font-semibold text-gray-800 mb-2 line-clamp-2">
          {blog.title}
        </h3>

        <p className="text-gray-500 text-sm line-clamp-3">
          {blog.excerpt}
        </p>

        <div className="flex items-center justify-between mt-5 text-xs text-gray-400">
          <span>{blog.author}</span>
          <span>{blog.readTime}</span>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
